import { useApi } from "utils"
import { InvoiceAdjustmentList, SuccessFetch, PaginationData } from "../types/invoiceAdjustmentTypes"
import { invoiceListStore } from "./invoiceListStore"

export function useInvoiceList() {
    const {
        filter,
        pagination_data,
        setData,
        setIsLoading,
        setPaginationData,
    } = invoiceListStore()

    const api = useApi()

    const fetchData = () => {
        setIsLoading(true)
    
        const params = {
            start_date: filter.DateFrom,
            end_date: filter.DateEnd,
            invoice_status: filter.invoice_status,
            search_key: filter.search,
            page: pagination_data.page,
            limit: pagination_data.limit,
            size: pagination_data.size
        }
      
        api.get("/invoice/list_adjustment_freight_invoice", { params })
            .then((res) => {
                const response: SuccessFetch<InvoiceAdjustmentList[], PaginationData> = res.data;
                const data = response.payload ?? [];
                setData(data);
                setPaginationData(response.pagination_data);
            })
            .catch(() => {
                setData([]);
                setPaginationData({
                    page: 1,
                    pages: 0,
                    total: 0,
                    limit:10,
                    keyword:''
                })
            })
            .finally(() => setIsLoading(false))
    }

    return {
        fetchData
    }
}